import React from "react";
import EmptyState from "../components/ui/EmptyState";
import InfoBanner from "../components/InfoBanner";

export default function DashboardInsights() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Insights</h1>
        <p className="mt-2 text-sm text-slate-600">
          Insights are not available yet.
        </p>
      </div>
      <InfoBanner
        title="Feature not ready"
        description="Insights will be available once the backend contract is finalized."
      />
      <EmptyState
        title="No insights yet"
        message="Insights will appear once data is available."
        testId="dashboard-empty-insights"
      />
    </div>
  );
}
